import { connectedComponent } from 'utils/redux/providerWrapper';
import UserNavigationButtons from './user_navigation_buttons';

export const ConnectedUserNavigationButtons = connectedComponent(
  UserNavigationButtons
);
